import { initSchema } from '@aws-amplify/datastore';
import { schema } from './schema';

const {
  AccountMaster,
  AccountOpeningBalance,
  AccountGroupMasterNew,
  AccountBalanceNew,
  AccountMasterv2,
  CognitoUserSession,
  OTPDetails,
  PhoneContacts,
  POSParty,
  hsnsacmaster,
  AccountGSTDetails,
  BankDetails,
  CodeTranslation,
  NumberTracker,
  UserPreference,
  CompanyPreference,
  CompanyDetails,
  FinancialYear,
  BusinessType,
  IndustryType,
  PriceType,
  Invoicemaster,
  InvoiceTCSDetails,
  InvoiceLineItems,
  InvoiceLineGST,
  itemmaster,
  ItemAmountDetails,
  ItemGstDetails,
  ItemImages,
  InvoiceLineNonItems,
  InvoiceAttachment,
  InvoiceDispatch,
  InvoicePOSDetails,
  InvoiceLineNonGST,
  InvoiceNumberTracker,
  TransactionMaster,
  TransactionDetailsCustom,
  TransactionAttachment,
  TransactionTDSDetails,
  PurchaseMasterNew,
  PurchaseTDSDetails,
  PurchaseLineItems,
  PurchaseLineGST,
  PurchaseLineNonItems,
  PurchaseAttachment,
  TransactionRelation,
  Invoicemasternew,
  partymaster,
  PartyGSTDetails,
  PartyCreditDetails,
  PartyContact,
  PartyImages,
  AddressEntity,
  PurchaseInvoiceList,
  EmailTemplateMaster,
  EmailSettings,
  eInvoiceMaster,
  TransactionMasterv2,
  LinkedReceipts,
  Location,
  partymasternew,
  PaymentSettings,
  PurchaseMaster,
  PurchaseTCSDetails,
  PurchaseLineNonGST,
  ReceiptDetails,
  ThemeColor,
  AccountBalancev2,
  UserThemePreference,
  AccountGroupMaster,
  AccountGroupMasterv2,
  CrDrNoteMaster,
  CrDrNoteInvoices,
  CrDrAttachment,
  CrDrNoteDetails,
  CrDrNoteLineItems,
  CrDrNoteLineNonItems,
  CrDrNoteTCSDetails,
  CrDrNoteTDSDetails,
  CrDrNoteDispatch,
  partymasterv2,
  PartyMasterListCount,
  LUTBondMaster,
  LineItemsList,
  ItemTablePreference,
  itemmasterv2,
  ItemMasterListCount,
  ItemLotDetails,
  ItemCategoryMaster,
  InvoiceSettings,
  Invoicemasterv2,
  InvoiceMasterListCount,
  Denomination,
  FinancialYearTransferHistory,
  FinancialYearStatus,
  EmailContacts,
  EInvoiceUsers,
  DeletedTransactionMaster,
  TransactionDetailsCustomDeleted,
  partymasterDeleted,
  itemmasterDeleted,
  ItemAmountDetailsDeleted,
  PurchaseMasterDeleted,
  InvoicemasterDeleted,
  AccountGroupMasterDeleted,
  CrDrNoteMasterDeleted,
  AccountMasterDeleted,
  PlaceOfSupply,
  AccountTransactionCount,
  RelatedAccountsTransactionDetails,
  AccountOpeningBalancev2,
  TransactionDetailsv3,
  Company,
  CompanyEntity,
  CompanyDocuments,
  TransactionDetails,
  TransactionMasterCount,
  TransactionDetailsGroupCustom,
  PurchaseMasterv2,
  PurchaseMasterListCount,
  PartyInvoicePurchases,
  CrDrNoteMasterv2,
  CrDrNoteMasterListCount,
  CompanyFullDetails,
  CompanyCodeTranslation,
  PartyCreation,
  SalesInvoiceTransaction,
  AccountBalance,
  PurchaseInvoice,
  TransactionSpecificTime,
  CrDrNoteInvoiceTransaction,
  AccountOpeningBalanceResponse,
  DeleteInvoiceStatus,
  SwitchCompany,
  RelatedPaymentDetails,
  TestEntry,
  DashboardBalances,
  BusinessOverview,
  Top5Expense,
  Success,
  DayBookTransactionDetails,
  OutstandingInvoicemaster,
  OutstandingPurchasemaster,
  MinMaxInvoiceDate,
  TransactionDetailsModalTotals,
  LambdaAIResponse,
  UserIssue,
  PosPartyDetails,
  TDSTCSReport,
  JournalDetails,
  TransporterMaster,
  EwayBill,
  AppVersion,
  FirstTransaction,
  EwayBillListCount,
  CheckItemPartyAdded,
  ItemOpeningStockResponse,
  ItemWiseStockSummary,
  StockSummary,
  UserInvitation,
  ItemOpeningStockDetails,
  ItemDashboardData,
  TotalClosingStock,
} = initSchema(schema);

export {
  AccountMaster,
  AccountOpeningBalance,
  AccountGroupMasterNew,
  AccountBalanceNew,
  AccountMasterv2,
  CognitoUserSession,
  OTPDetails,
  PhoneContacts,
  POSParty,
  hsnsacmaster,
  AccountGSTDetails,
  BankDetails,
  CodeTranslation,
  NumberTracker,
  UserPreference,
  CompanyPreference,
  CompanyDetails,
  FinancialYear,
  BusinessType,
  IndustryType,
  PriceType,
  Invoicemaster,
  InvoiceTCSDetails,
  InvoiceLineItems,
  InvoiceLineGST,
  itemmaster,
  ItemAmountDetails,
  ItemGstDetails,
  ItemImages,
  InvoiceLineNonItems,
  InvoiceAttachment,
  InvoiceDispatch,
  InvoicePOSDetails,
  InvoiceLineNonGST,
  InvoiceNumberTracker,
  TransactionMaster,
  TransactionDetailsCustom,
  TransactionAttachment,
  TransactionTDSDetails,
  PurchaseMasterNew,
  PurchaseTDSDetails,
  PurchaseLineItems,
  PurchaseLineGST,
  PurchaseLineNonItems,
  PurchaseAttachment,
  TransactionRelation,
  Invoicemasternew,
  partymaster,
  PartyGSTDetails,
  PartyCreditDetails,
  PartyContact,
  PartyImages,
  AddressEntity,
  PurchaseInvoiceList,
  EmailTemplateMaster,
  EmailSettings,
  eInvoiceMaster,
  TransactionMasterv2,
  LinkedReceipts,
  Location,
  partymasternew,
  PaymentSettings,
  PurchaseMaster,
  PurchaseTCSDetails,
  PurchaseLineNonGST,
  ReceiptDetails,
  ThemeColor,
  AccountBalancev2,
  UserThemePreference,
  AccountGroupMaster,
  AccountGroupMasterv2,
  CrDrNoteMaster,
  CrDrNoteInvoices,
  CrDrAttachment,
  CrDrNoteDetails,
  CrDrNoteLineItems,
  CrDrNoteLineNonItems,
  CrDrNoteTCSDetails,
  CrDrNoteTDSDetails,
  CrDrNoteDispatch,
  partymasterv2,
  PartyMasterListCount,
  LUTBondMaster,
  LineItemsList,
  ItemTablePreference,
  itemmasterv2,
  ItemMasterListCount,
  ItemLotDetails,
  ItemCategoryMaster,
  InvoiceSettings,
  Invoicemasterv2,
  InvoiceMasterListCount,
  Denomination,
  FinancialYearTransferHistory,
  FinancialYearStatus,
  EmailContacts,
  EInvoiceUsers,
  DeletedTransactionMaster,
  TransactionDetailsCustomDeleted,
  partymasterDeleted,
  itemmasterDeleted,
  ItemAmountDetailsDeleted,
  PurchaseMasterDeleted,
  InvoicemasterDeleted,
  AccountGroupMasterDeleted,
  CrDrNoteMasterDeleted,
  AccountMasterDeleted,
  PlaceOfSupply,
  AccountTransactionCount,
  RelatedAccountsTransactionDetails,
  AccountOpeningBalancev2,
  TransactionDetailsv3,
  Company,
  CompanyEntity,
  CompanyDocuments,
  TransactionDetails,
  TransactionMasterCount,
  TransactionDetailsGroupCustom,
  PurchaseMasterv2,
  PurchaseMasterListCount,
  PartyInvoicePurchases,
  CrDrNoteMasterv2,
  CrDrNoteMasterListCount,
  CompanyFullDetails,
  CompanyCodeTranslation,
  PartyCreation,
  SalesInvoiceTransaction,
  AccountBalance,
  PurchaseInvoice,
  TransactionSpecificTime,
  CrDrNoteInvoiceTransaction,
  AccountOpeningBalanceResponse,
  DeleteInvoiceStatus,
  SwitchCompany,
  RelatedPaymentDetails,
  TestEntry,
  DashboardBalances,
  BusinessOverview,
  Top5Expense,
  Success,
  DayBookTransactionDetails,
  OutstandingInvoicemaster,
  OutstandingPurchasemaster,
  MinMaxInvoiceDate,
  TransactionDetailsModalTotals,
  LambdaAIResponse,
  UserIssue,
  PosPartyDetails,
  TDSTCSReport,
  JournalDetails,
  TransporterMaster,
  EwayBill,
  AppVersion,
  FirstTransaction,
  EwayBillListCount,
  CheckItemPartyAdded,
  ItemOpeningStockResponse,
  ItemWiseStockSummary,
  StockSummary,
  UserInvitation,
  ItemOpeningStockDetails,
  ItemDashboardData,
  TotalClosingStock,
};
